export default {
    getCurrUser:'user/current',
    getList:'dataset',
    login:'session',  
}
